import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Input, message, Popconfirm, Space, Spin, Table } from "antd";
import { productApi } from "api/product.api";
import { Pagination } from "components/Pagination";
import React, { useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import { QueryParam } from "types/query";
import { Product, ProductProperty } from "types/product";
import { getTitle } from "utils";
import { $url } from "utils/url";
import { ProductPropertyModal } from "./ProductPropertyModal";
import { productPropertyApi } from "api/product-property.api";
// import { ProductModal } from "./components/ProductModal";

const { ColumnGroup, Column } = Table;

export const ProductPropertyTab = ({ productId = 0 }) => {
  const [query, setQuery] = useState<QueryParam>({
    page: 1,
    limit: 50,
    search: "",
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ProductProperty[]>([]);
  const [total, setTotal] = useState(0);
  const [visibleModal, setVisibleModal] = useState(false);
  const [selectedProductProperty, setSelectedProductProperty] = useState<
    Partial<Product>
  >({});
  const [modalStatus, setModalStatus] = useState<ModalStatus>("create");

  useEffect(() => {}, []);

  useEffect(() => {
    fetchData();
  }, [query]);

  useEffect(() => {
    if (productId) {
      fetchData();
    }
  }, [productId]);

  const fetchData = async () => {
    setLoading(true);
    const res = await productApi.findOne(productId);
    setLoading(false);
    setData(res.data.productProperties);
  };

  const handleDelete = async (row: ProductProperty) => {
    setLoading(true);
    try {
      await productPropertyApi.delete(row.id);
      message.success("Xóa thành công");
      fetchData();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="filter-container">
        <Space>
          <div className="filter-item btn">
            <Button
              onClick={() => {
                setVisibleModal(true);
                setModalStatus("create");
              }}
              type="primary"
              icon={<PlusOutlined />}
            >
              Thêm mới
            </Button>
          </div>
        </Space>
      </div>

      <Spin spinning={loading}>
        <Table pagination={false} rowKey="id" dataSource={data}>
          <Column title="Key" dataIndex="key" />
          <Column title="Giá trị" dataIndex="value" />

          <Column
            title="Thao tác"
            key="action"
            render={(text, record: ProductProperty) => (
              <span>
                <Space>
                  <Button
                    type="primary"
                    onClick={() => {
                      setSelectedProductProperty(record);
                      setVisibleModal(true);
                      setModalStatus("update");
                    }}
                  >
                    Cập nhật
                  </Button>

                  <Popconfirm
                    onConfirm={() => handleDelete(record)}
                    placement="top"
                    title="Xác nhận xóa"
                  >
                    <Button danger>Xóa</Button>
                  </Popconfirm>
                </Space>
              </span>
            )}
          />
        </Table>
      </Spin>

      <ProductPropertyModal
        productId={productId}
        onSubmitOk={fetchData}
        onClose={() => setVisibleModal(false)}
        visible={visibleModal}
        productProperty={selectedProductProperty}
        status={modalStatus}
      />
    </div>
  );
};
